import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { SuperAcessoStruct } from '../../structs/usuario-admin/super-acesso.struct';
import { ListaSuperAcessoResponse } from '../../responses/usuario-admin/lista-super-acesso.response';
import { SuperAcessoRequest } from '../../requests/usuario-admin/super-acesso.request';

@Injectable({
  providedIn: 'root',
})
export class SuperAcessoService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public Incluir(criarSuperAcessoRequest: SuperAcessoRequest): Observable<SuperAcessoStruct> {
    return this.httpClient
      .post<SuperAcessoStruct>(
        environment.urlApiUsuarioAdmin + `superacessoadmin`,
        criarSuperAcessoRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public ObterListaSuperAcesso(
    listaSuperAcessoRequest: SuperAcessoRequest,
    paginaAtual: number
  ): Observable<ListaSuperAcessoResponse> {
    return this.httpClient
      .post<ListaSuperAcessoResponse>(
        environment.urlApiUsuarioAdmin + `superacessoadmin/listasuperacesso/?pagina=${paginaAtual}`,
        listaSuperAcessoRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
